const riskAssessment = {
  assignRisk: 'Assign risk',
  assignedRiskProfile: 'Assigned risk profile',
  cdd: 'CDD',
  confirmRisk:
    'This is the current calculated risk indicator. Do you confirm the assignment of the calculated value?',
  customRiskProfile: 'Custom risk profile',
  dueDiligence: 'Due Diligence',
  edd: 'EDD',
  factorWeight: 'Factor weight',
  notarizeCdd: 'Notarize Basic Customer Due Diligence',
  notarizeEdd: 'Notarize Enhanced Customer Due Diligence',
  profilerData: 'Profiler data',
  questionnaire: 'Questionnaire',
  riskAssessment: 'Risk assessment',
  riskLevel: 'Risk level',
  updateRisk: 'Update risk',
};

export default riskAssessment;
